<template>
  <div>...wait</div>
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>
